import { render, staticRenderFns } from "./policy-info.vue?vue&type=template&id=e1ddc4be&"
import script from "./policy-info.vue?vue&type=script&lang=js&"
export * from "./policy-info.vue?vue&type=script&lang=js&"
import style0 from "./policy-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports